import { NgModule } from '@angular/core';
import { RedirectComponent } from './redirect.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { RedirectRoutingModule } from './redirect-routing.module';

@NgModule({
    imports: [CommonModule, SharedModule, RedirectRoutingModule],
    declarations: [RedirectComponent],
    exports: [RedirectComponent],
    providers: []
})
export class RedirectModule {}
